module.exports = __webpack_public_path__ + "img/partner-supraco.de52cc02.png";